const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';

const AccountDetailApiService = {
    // Method for handling the signup API call
    
    Update: async (data) => {
      try {
        const apiEndpoint = `${baseUrl}Setting/AccountDetail`; // Complete URL for the signup endpoint
  
        const response = await fetch(apiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data), // Convert data to JSON
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Update User Detail error:', error);
        throw new Error('Network error');
      }
    },

    Get: async (data) => {
        try {
          var UserId = data;
          const apiEndpoint = `${baseUrl}Setting/Get/`+ UserId; // Complete URL for the test endpoint
    
          const response = await fetch(apiEndpoint, {
            method: 'GET', // Correctly capitalized method
            headers: {
              'Content-Type': 'application/json',
            },
          });
    
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error occurred');
          }
    
          const result = await response.json(); // Parse the JSON response
          return result; // Return response data on success
        } catch (error) {
          console.error('Error:', error);
          throw new Error('Network error');
        }
      },
    
    
  };
  
  export default AccountDetailApiService;
  